import React from 'react'

export function PiUploadIcon() {
  return (
    <svg
      width='32'
      height='33'
      viewBox='0 0 32 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.33337 22.2969V23.6302C5.33337 24.6911 5.7548 25.7085 6.50495 26.4586C7.25509 27.2088 8.27251 27.6302 9.33337 27.6302H22.6667C23.7276 27.6302 24.745 27.2088 25.4951 26.4586C26.2453 25.7085 26.6667 24.6911 26.6667 23.6302V22.2969M21.3334 11.6302L16 6.29688M16 6.29688L10.6667 11.6302M16 6.29688V22.2969'
        stroke='#134C85'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
